import React from 'react';
import './css/heroyoga.css';

export default function Heroyoga() {
    return (
        <div>
            <div className="herosectionyoga">
                <div className="leftsection">
                    <div className="textsection">
                        <div className="heading">Do yoga, Get good health</div>
                        <div className="subheading">Lorem ipsum dolor, lectus sit lorem id integer.</div>
                    </div>
                    <div className="button">Get Started</div>
                </div>
                <div className="rightsection">
                    <div className='box'>
                        <img src='https://res.cloudinary.com/dzbdnlr0f/image/upload/v1641662800/hibernation-hack/mainimage_u2ogtw.svg' alt='' className='landingimage'/>
                    </div>
                </div>
            </div>
        </div>
    )
}
